<h2 style="max-width: 455px" mat-dialog-title>
	{{ data.titleKey | transloco }}
</h2>
<mat-dialog-content>
	@if (data.messageKey) {
		<p>{{ data.messageKey | transloco: data.messageParams }}</p>
	}
	@if (data.contextLabel) {
		<p>
			<strong>{{ data.contextLabel }}</strong>
		</p>
	}
	@if (data.confirmInputText) {
		<lvr-field [label]="data.confirmInputLabelKey ?? '' | transloco">
			<mat-form-field lvrInput class="full-width">
				<input
					matInput
					[(ngModel)]="confirmationInput"
					[placeholder]="
						data.confirmInputPlaceholderKey ?? ''
							| transloco: data.confirmInputPlaceholderParams ?? { value: data.confirmInputText }
					"
				/>
			</mat-form-field>
		</lvr-field>
	}
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="data.cancelKey ?? 'base.button.cancel' | transloco"
		[type]="'button'"
		[mat-dialog-close]="false"
		[icon]="'disabled_by_default'"
	></lvr-button>
	<lvr-button
		variant="primary"
		[label]="data.confirmKey ?? 'base.button.delete' | transloco"
		[loadingLabel]="data.loadingLabel ?? 'base.button.delete' | transloco"
		[loading]="isLoading()"
		[type]="'button'"
		(clicked)="confirm()"
		[disabled]="!isConfirmEnabled()"
		[icon]="'delete'"
	></lvr-button>
</mat-dialog-actions>
